webpackJsonp([54],{

/***/ 1266:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".sidebar,.sidebar-button{display:none}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/sidebar/SidebarStandard1/src/components/sidebar/SidebarStandard1/SidebarStandard1.m.scss"],"names":[],"mappings":"AAIE,yBACE,YAAa,CACd","file":"SidebarStandard1.m.scss","sourcesContent":["@import '~scss/variables';\n\n.sidebar {\n  display: none;\n  &-button {\n    display: none;\n  }\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1266);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("6aa60a24", content, true, {});

/***/ })

});


// WEBPACK FOOTER //
// static/js/54.fa5281fef15b6efef6b7.js